import React from 'react';
import { FilledInput } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-premium';
import type { GridEditCellValueParams } from '@mui/x-data-grid-premium';

import type { EditInputCellParams } from '../DetailsSectionTableInputCells';

type TextEditInputCellParams = EditInputCellParams<string> & {
	rows?: number;
};

function TextEditInputCell(props: TextEditInputCellParams) {
	const apiRef = useGridApiContext();

	const inputRef = React.useRef<HTMLInputElement>(undefined);

	const [valueState, setValueState] = React.useState(props.value || '');
	const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>();

	const handleRef = React.useCallback((el: HTMLElement | null) => {
		setAnchorEl(el);
	}, []);

	const handleChange = React.useCallback<React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>>(
		event => {
			const newValue = event.target.value;
			setValueState(newValue || '');
			const editCellParams: GridEditCellValueParams = {
				id: props.id,
				field: props.field,
				value: newValue,
				debounceMs: 200
			};
			apiRef.current.setEditCellValue(editCellParams, event);
		},
		[apiRef, props.field, props.id]
	);

	const handleKeyDown: React.KeyboardEventHandler<HTMLInputElement> = async event => {
		if (event.key === 'Enter') {
			event.preventDefault();
			event.stopPropagation();
		}
	};

	React.useEffect(() => {
		if (props.hasFocus) inputRef.current?.focus();
	}, [props.hasFocus]);

	return (
		// <div className={props.className} style={{ position: 'relative', alignSelf: 'flex-start' }}>
		// 	<Box ref={handleRef} className="absolute top-0 block" width={props.colDef.computedWidth} />
		// 	{anchorEl && (
		// 		<Popper open anchorEl={anchorEl} placement="bottom-start">
		// 			<Paper
		// 				sx={{ minWidth: props.colDef.computedWidth }}
		// 				elevation={props.hasFocus && (props.rows || 0) > 0 ? 1 : 0}
		// 			>
		<FilledInput
			className="h-full w-full rounded-none p-0"
			classes={{ input: 'p-8' }}
			sx={{ textarea: { padding: 1, resize: 'both' } }}
			inputRef={inputRef}
			value={valueState}
			onChange={handleChange}
			onKeyDown={handleKeyDown}
			disableUnderline
			// multiline={!!props.rows}
			// rows={props.hasFocus ? props.rows : 1}
		/>
		// 			</Paper>
		// 		</Popper>
		// 	)}
		// </div>
	);
}

export default React.memo(TextEditInputCell);
